import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";

import { loginAccount } from '../../../models/account';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { AuthService } from '../../../shared/services/authentication/auth.service'; //'../_services/auth.service'
import { TokenStorageService } from '../../../shared/services/authentication/token-storage.service'; //'../_services/token-storage.service'
import { ToastrService } from 'ngx-toastr';
import { SignalrService } from 'src/app/shared/services/websecket/signalr.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  account = new loginAccount();
  isLoggedIn = false;
  isLoginFailed = false;
  roles: any[] = [];
  rolesName: string[] = [];

  constructor(private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private toastrService: ToastrService,
    private signalrService: SignalrService ) { 
      this.loginForm = this.fb.group({
        userName: ['', Validators.required],
        password: ['', [Validators.required, Validators.minLength(8)]]
      });
    }

  ngOnInit() { 
    // ustawienie minut do wylogowania

    if(this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.roles = this.tokenStorage.getUser().roles;
    }
  }

  login() {

      //localStorage.setItem("user", JSON.stringify(user));
      this.router.navigate(["/dashboard/default"]);
    
  }

  onSubmit(): void{
    this.account.username = this.loginForm.value['userName'];
    this.account.password = this.loginForm.value['password'];

    this.authService.login(this.account).subscribe(
      data => {
        if(data.errors)
        {
          this.toastrService.error(data.errors[0].message, 'Error !');
        }
        else
        {
          //console.log("DATA: ", data);
          this.tokenStorage.saveToken(data.data.token);
          this.tokenStorage.saveUser(data.data);

          var startTime = new Date();
          var endTime = new Date(data.data.tokenExpirationTime);
          var difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
          //var resultInMinutes = Math.round(difference / 60000);
          //console.log("DIFF: ", difference, resultInMinutes);

          // automatyczne wylogowanie po ustalonym (30min) czasie
          setTimeout(()=>{
            this.toastrService.success('You will be automatically logout in 5sec.', 'Info');
            setTimeout(()=>{
              this.tokenStorage.signOut();
              window.location.href='/';
            }, 6000);
          }, difference);

          this.isLoginFailed = false;
          this.isLoggedIn = true;
          this.roles = this.tokenStorage.getUser().roles;

          //this.reloadPage();
          for(let i=0;i<data.data.roles.length;i++)
            this.rolesName[i]=data.data.roles[i].name

          if(this.rolesName.includes('ROLE_ADMIN'))
            this.router.navigate(['/adm/dashboard']);
            // this.router.navigate(["/dashboard/default"]);
          else
          {
            // uruchomienie websocket dla informowania o nowych konwersji
            this.signalrService.startConnection();
            this.signalrService.newConversionListener();

            this.router.navigate(['/pub/dashboard']);
            // this.router.navigate(["/dashboard/default"]);
          }
        }
      },
      err => {
        if(err.status==403)
        {
          // zmiana hasła wymagana
          this.toastrService.error('You have to change password.', 'Error !');
          this.router.navigate(['/authentication/forgetpassword']);
        }
        else
        {
          this.isLoginFailed = true;
        }
      }
    );
  }

  onKey(event: any) { // without type info
    this.isLoginFailed = false;
  }

  reloadPage(): void {
    window.location.reload();
  }
}
